import * as React from "react";
import styled, { css } from "styled-components";
import Menu from "components/bootstrap/Menu";
import Icon from "components/common/Icon";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { MenuItem } from "components/bootstrap";
const DropdownTrigger = styled.button(
  ({ theme }) => css`
    background: transparent;
    border: 0;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    line-height: normal;

    &:focus-visible {
      outline-offset: 2px;
    }
  `
);
const MenuItemLabel = styled.span(
  ({ $active }) => css`
    font-weight: ${$active ? "bold" : "inherit"};
  `
);
const HeaderActionsDropdown = ({
  children,
  label,
  activeSort = false,
  isSliceActive = false,
  onChangeSlicing,
  sliceColumnId = void 0,
  appSection = void 0,
  onSort = void 0
}) => {
  const sendTelemetry = useSendTelemetry();
  const hasActions = Boolean(onChangeSlicing || onSort);
  const onToggleSlicing = () => {
    if (isSliceActive) {
      sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_REMOVED, {
        app_section: appSection,
        app_action_value: "slice-remove",
        event_details: { attribute_id: sliceColumnId }
      });
      return onChangeSlicing(void 0, void 0);
    }
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_COLUMN_SELECTED_HEADER, {
      app_section: appSection,
      app_action_value: "slice-column-header",
      event_details: { attribute_id: sliceColumnId }
    });
    return onChangeSlicing(sliceColumnId);
  };
  if (!hasActions) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(Menu, { shadow: "md", withinPortal: true, position: "bottom-start" }, /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(DropdownTrigger, { type: "button", title: `Toggle ${label} actions`, "aria-label": `Toggle ${label} actions` }, /* @__PURE__ */ React.createElement("span", null, children), /* @__PURE__ */ React.createElement(Icon, { name: "arrow_drop_down", size: "xs" }))), /* @__PURE__ */ React.createElement(Menu.Dropdown, null, onSort && /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => onSort(false), icon: "arrow_upward" }, /* @__PURE__ */ React.createElement(MenuItemLabel, { $active: activeSort === "asc" }, "Sort ascending")), onSort && /* @__PURE__ */ React.createElement(MenuItem, { onClick: () => onSort(true), icon: "arrow_downward" }, /* @__PURE__ */ React.createElement(MenuItemLabel, { $active: activeSort === "desc" }, "Sort descending")), onSort && onChangeSlicing && /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), onChangeSlicing && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onToggleSlicing, icon: "surgical" }, isSliceActive ? "No slicing" : "Slice by values")));
};
export default HeaderActionsDropdown;
